export default "__VITE_PUBLIC_ASSET__b0fea44d__"